module.exports = __webpack_public_path__ + "media/20.ea102871.wav";